import type { PricingTranslation } from './types'

/**
 * Urdu translations for Pricing domain
 */
export const pricingTranslationUr: PricingTranslation = {
  title: 'قیمتوں کا تعین',
  description: 'نظام میں قیمتوں کا تعین کا انتظام کریں',
  actions: {
    create: 'قیمت بنائیں',
    edit: 'قیمت میں ترمیم کریں',
    delete: 'قیمت حذف کریں',
    view: 'قیمت دیکھیں',
    save: 'محفوظ کریں',
    cancel: 'منسوخ کریں',
  },
  form: {
    name: 'نام',
    description: 'تفصیل',
    status: 'حالت',
  },
  status: {
    active: 'فعال',
    inactive: 'غیر فعال',
    pending: 'زیر التوا',
  },
  messages: {
    created: 'قیمت کامیابی سے بنائی گئی',
    updated: 'قیمت کامیابی سے اپ ڈیٹ ہوئی',
    deleted: 'قیمت کامیابی سے حذف ہوئی',
    error: 'ایک خرابی پیش آ گئی',
  },
}
